import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { listProjectCustomData } from '~/api/projectCustomData';
import { customDataQueryKey, customDataRefetchInterval } from '~/pages/projectDetails/filesAndMedia/CustomDataSection';
import { buildCustomDataCategoryLabelMap } from './customDataLayers.helpers';

/**
 * The project's custom-data category display names, for the metadata sidebar,
 * which sees only a raw `CateTitle`.
 *
 * Reads through the same cached query the map layers and legend already populate, so mounting this
 * adds no request. Empty until the rows land, which resolves every category to its humanized value.
 */
export function useCustomDataCategoryLabels(projectId: string | undefined): Map<string, string> {
  const enabled = !!projectId;
  const { data: rows } = useQuery({
    enabled,
    refetchOnWindowFocus: false,
    queryKey: customDataQueryKey(projectId ?? ''),
    queryFn: () => listProjectCustomData(projectId ?? ''),
    refetchInterval: customDataRefetchInterval,
  });
  return useMemo(() => buildCustomDataCategoryLabelMap(enabled ? rows : undefined), [enabled, rows]);
}
